'use strict';exports.__esModule = true;exports.getIconStatus = getIconStatus;exports.







addEnding = addEnding;function getIconStatus(isActive, promotion) {if (isActive) {return 'active';}var _ref = promotion || {},allowed = _ref.allowed,promoted = _ref.promoted;return allowed - promoted ? '' : 'disabled';}function addEnding(status) {
  return '' + (status && '-' + status);
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/getIconStatus.js
// module id = 292
// module chunks = 0